import React, { forwardRef } from "react";
import { BSHeading } from "../../types";

export const AlertHeading = forwardRef<HTMLHeadingElement, BSHeading>(
  ({ children, className = "", component: Component = "h4", ...props }, ref) => (
    <Component ref={ref} {...props} className={`alert-heading ${className}`}>
      {children}
    </Component>
  )
);